import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {toEmbedUrl} from './media';

/**
 * La galería de un paso: imágenes/GIF y videos embebidos, de a uno, con flechas y puntos si hay más
 * de uno. Un video de un dominio no permitido NO se dibuja (el Backend ya lo rechaza al guardar;
 * esto cubre un dato viejo).
 */
export function GuideMedia({items}) {
    const {t} = useTranslation();
    const [current, setCurrent] = useState(0);
    const media = (items || []).filter((item) => item && item.url);
    if (media.length === 0) return null;

    const index = Math.min(current, media.length - 1);
    const item = media[index];
    const embedUrl = item.kind === 'embed' ? toEmbedUrl(item.url) : null;

    return (
        <figure className="guide-media">
            <div className="guide-media-frame">
                {item.kind === 'embed' && embedUrl && (
                    <iframe
                        src={embedUrl}
                        title={item.caption || t('guides.video_title')}
                        loading="lazy"
                        allow="fullscreen; picture-in-picture"
                        allowFullScreen
                        sandbox="allow-scripts allow-same-origin allow-presentation allow-popups"
                    />
                )}
                {item.kind === 'image' && (
                    <img src={item.url} alt={item.caption || ''} loading="lazy"/>
                )}
            </div>
            {item.caption && <figcaption>{item.caption}</figcaption>}
            {media.length > 1 && (
                <div className="guide-media-nav">
                    <button type="button" className="guide-media-arrow" aria-label={t('guides.media_prev')}
                            disabled={index === 0} onClick={() => setCurrent(index - 1)}>‹</button>
                    <div className="guide-media-dots">
                        {media.map((m, i) => (
                            <button key={`${m.url}-${i}`} type="button"
                                    className={`guide-media-dot${i === index ? ' -active' : ''}`}
                                    aria-label={t('guides.media_go', {n: i + 1})}
                                    aria-current={i === index}
                                    onClick={() => setCurrent(i)}>
                                <span className="guide-media-dot-mark"/>
                            </button>
                        ))}
                    </div>
                    <button type="button" className="guide-media-arrow" aria-label={t('guides.media_next')}
                            disabled={index === media.length - 1} onClick={() => setCurrent(index + 1)}>›</button>
                </div>
            )}
        </figure>
    );
}
